import React from "react";
import { Box, Flex, Span } from "@catchoftheday/cg-components";
export const Step = ({ active = false, step = 1, description = "", last = false, }) => {
    return (<Flex position="relative" zIndex={1} alignItems="flex-start" mb={last ? 0 : 4}>
      {last && (<Box position="absolute" borderTopLeftRadius="50%" borderTopRightRadius="50%" backgroundColor="white" overflow="hidden" top={0} bottom={0} left={0} width="24px" zIndex={-1}/>)}
      <Box>
        <Box width="24px" height="24px" borderRadius="50%" borderColor="onePass.primary" borderStyle="solid" borderWidth="1px" overflow="hidden" color={active ? "white" : "onePass.primary"} backgroundColor={active ? "onePass.primary" : "white"} textAlign="center">
          <Span fontWeight="bold" fontSize="base" lineHeight={1}>
            {step}
          </Span>
        </Box>
      </Box>
      <Span ml={2} fontSize="base" fontWeight="medium" color="onePass.textPrimary">
        {description}
      </Span>
    </Flex>);
};
